/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams,
  PostApiV1IndividualpaymentParcelsParcelidReversePayment400,
  PostApiV1IndividualpaymentParcelsParcelidReversePayment401,
  PostApiV1IndividualpaymentParcelsParcelidReversePayment500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidReversePayment.ts";

function getPostApiV1IndividualpaymentParcelsParcelidReversePaymentUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/reverse-payment` as const,
  };
  return res;
}

/**
 * @description Parcela paga volta a pendente, com data/valor pago limpos e observação de estorno. Migrado do legado IndividualPayment/ReversePayment. **(Requer Authorization para autenticação)**
 * @summary Estorno lógico do pagamento (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/reverse-payment}
 */
export async function postApiV1IndividualpaymentParcelsParcelidReversePayment(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams["parcelId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment400
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment401
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidReversePaymentUrl(
      parcelId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
